var oup_member_access = (function ($) {

    const _init = function () {
        if ($('.page-oup-member-access').length) {
            _redirect_to_oup();
        }
    };

    const _redirect_to_oup = function () {
        const accessUrl = scriptData.oupMemberAccessUrl;

        if (accessUrl) {
            window.location.href = accessUrl;
        }
    };

    $(document).ready(_init);

    return {};

})(jQuery);

module.exports = oup_member_access;